import { createMutation } from 'react-query-kit';

import { createData, removeData, updateData } from 'services/http/http';
import portalSchema from 'support/types/schema-portal';

type ApproveReviewParameters = portalSchema.paths['/v1/reviews/{id}/approve']['put']['parameters']['path'];
type ApproveReviewBody = NonNullable<
  portalSchema.paths['/v1/reviews/{id}/approve']['put']['requestBody']
>['content']['application/json'];
export const useApproveReview = createMutation<void, ApproveReviewParameters & Partial<ApproveReviewBody>, Error>({
  mutationFn: async (variables) => {
    await updateData<void>(`/v1/reviews/${variables.id}/approve`, {
      ...(variables.approved_decision && { approved_decision: variables.approved_decision }),
      ...(variables.annotation_ids && variables.annotation_ids.length > 0
        ? { annotation_ids: variables.annotation_ids }
        : {}),
    });
  },
});

type CommentReviewParameters = portalSchema.paths['/v1/reviews/{id}/comment']['post']['parameters']['path'];
type CommentReviewBody =
  portalSchema.paths['/v1/reviews/{id}/comment']['post']['requestBody']['content']['application/json'];
export const useCommentReview = createMutation<void, CommentReviewParameters & CommentReviewBody, Error>({
  mutationFn: async (variables) => {
    await createData<void>(`/v1/reviews/${variables.id}/comment`, {
      comment: variables.comment,
    });
  },
});

type DeleteCommentFromReviewParameters =
  portalSchema.paths['/v1/reviews/{id}/comment/{commentId}']['delete']['parameters']['path'];
export const useDeleteCommentFromReview = createMutation<void, DeleteCommentFromReviewParameters, Error>({
  mutationFn: async (variables) => {
    await removeData<void>(`/v1/reviews/${variables.id}/comment/${variables.commentId}`);
  },
});
